import { inject } from '@angular/core';

export const publicGuard = () => {
  // Always allow access to public routes
  return true;
};
